import Cookies from 'js-cookie'
import psl from 'psl'

const TokenKey = 'areacode'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    const domain = psl.get(document.domain)
    if (!domain || domain === '0.1') {
        Cookies.set(TokenKey, token)
    } else {
        Cookies.set(TokenKey, token, { domain: '.' + domain })
    }
}

export function setCookie(key, value) {
    const domain = psl.get(document.domain)
    if (!domain || domain === '0.1') {
        Cookies.set(key, value)
    } else {
        Cookies.set(key, value, { domain: '.' + domain })
    }
}

export function getCookie(key) {
    return Cookies.get(key)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}
